import { Component } from '@angular/core';

@Component({
  selector: 'page-not-found',
  templateUrl: 'page-not-found.html',
})
export class PageNotFoundComponent {}
